import { createFileRoute } from '@tanstack/react-router';
import { getDwpCopy } from '@/components/devil-wears-prada/dwp-copy';
import {
  DWP_OG_IMAGE,
  DWP_PATH,
} from '@/components/devil-wears-prada/dwp-json-ld';
import { DwpPage } from '@/components/devil-wears-prada/dwp-page';
import { isCurrentLocaleIndexablePath } from '@/lib/locale';
import { seo } from '@/lib/seo';
import { getImageUrl } from '@/lib/urls';

export const Route = createFileRoute('/devil-wears-prada-ai')({
  head: () => {
    const copy = getDwpCopy();
    const metadata = seo(DWP_PATH, {
      title: copy.seoTitle,
      description: copy.seoDescription,
      keywords: copy.keywords.join(', '),
      image: getImageUrl(DWP_OG_IMAGE),
    });
    // Untranslated locales keep the `noindex` from `seo()`.
    if (!isCurrentLocaleIndexablePath(DWP_PATH)) return metadata;
    return {
      ...metadata,
      meta: [
        ...metadata.meta,
        { name: 'robots', content: 'index, follow, max-image-preview:large' },
      ],
    };
  },
  component: DwpPage,
});
